"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
function default_1({ paymentDetail, whoAmI, confirm, }) {
    let isAgeCertified = false;
    const { room_payment_approval_cd_id } = paymentDetail;
    const isCertifiedRequired = room_payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_01';
    const isParentalConsent = room_payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_00';
    const isAdultOnly = room_payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_02' ||
        room_payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_05';
    const isUnder14 = room_payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_04';
    const isUserCertified = whoAmI.is_certified;
    const isAgentAgree = whoAmI.agent_agree;
    const isUserUnder19 = whoAmI.is_under_19;
    const isUserUnder14 = whoAmI.is_under_14;
    const settingRequiredConfirm = ({ description, noFromUrl, }) => {
        confirm({
            description,
            confirmationText: i18next_1.default.t('인증하기'),
        })
            .then(() => (window.location.href = `/member/setting${noFromUrl ? '' : `?from=${window.location.pathname}`}`))
            .catch(() => { });
    };
    if (isCertifiedRequired && !isUserCertified) {
        settingRequiredConfirm({ description: i18next_1.default.t('작가님 요청으로 본인인증이 필요해요') });
    }
    else if (isParentalConsent && !isUserCertified) {
        settingRequiredConfirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('본인인증 및 법정대리인 동의가 필요해요')] })),
            noFromUrl: true,
        });
    }
    else if (isParentalConsent && isUserCertified && isUserUnder19 && !isAgentAgree) {
        settingRequiredConfirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('법정대리인 동의가 필요해요')] })),
        });
    }
    else if (isUnder14 && isUserUnder14) {
        settingRequiredConfirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로 만 14세 이상만'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('구매할 수 있어요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('만 나이는 생일이 지나야 해요')}:)`] })),
        });
    }
    else if (isAdultOnly && isUserUnder19) {
        settingRequiredConfirm({
            description: i18next_1.default.t('작가님 요청으로 19세 성인인증이 필요해요'),
        });
    }
    else {
        isAgeCertified = true;
    }
    return isAgeCertified;
}
exports.default = default_1;
